import styled from 'styled-components';

export const ConsentAcceptActionButtonWrapper = styled.div`
  padding: 0px 48px 0px 48px;
`;
